module.exports = __webpack_public_path__ + "static/media/G1246957_Japan-16.a51ef17b.png";